<template>
  <modal-component
    :is-displayed="isCreateRelationModalOpened"
    :no-padding="true"
    :title="$t('DeviceTypes.CreateRelationTitle')"
    @toggle-modal="$emit('toggle-modal')"
  >
    <form-wrapper :is-form-in-modal="true">
      <form @submit.prevent="handleSubmit">
        <form-divider>
          <div class="relative items-center py-4">
            <label
              class="whitespace-nowrap text-sm font-medium not-italic text-gray-800"
              >{{ $t("DeviceTypes.DeviceTypeMetadata") }}</label
            >
            <div class="flex items-center justify-center">
              <small-loader v-if="isLoading" height="h-8" width="w-8" />
              <v-select
                v-else
                v-model="deviceTypeMetadataId"
                :class="`mt-1 w-full`"
                :options="deviceTypeMetadata"
                :reduce="(deviceType : any) => deviceType.id"
                label="name"
              ></v-select>
            </div>
          </div>
        </form-divider>
        <button-wrapper />
      </form>
    </form-wrapper>
  </modal-component>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import ModalComponent from "@/core/Components/Modal.vue";
import FormWrapper from "@/core/Components/FormElements/FormWrapper.vue";
import FormDivider from "@/core/Components/FormElements/FormDivider.vue";
import ButtonWrapper from "@/core/Components/FormElements/ButtonWrapper.vue";
import VSelect from "vue-select";
import SmallLoader from "@/core/Components/SmallLoader.vue";
import { DeviceTypeMetadataService } from "@/modules/Production/Submodules/DeviceTypeMetadata/Services/DeviceTypeMetadataService";
import { DeviceTypeMetadata } from "@/modules/Production/Submodules/DeviceTypeMetadata/Services/DeviceTypeMetadataTypes";
import { useToast } from "vue-toastification";
import { ErrorMessageFormatter } from "@/core/Services/GlobalFunctions";

export default defineComponent({
  components: {
    SmallLoader,
    VSelect,
    ButtonWrapper,
    FormDivider,
    FormWrapper,
    ModalComponent,
  },
  props: {
    isCreateRelationModalOpened: Boolean,
    deviceTypeIdList: {
      type: Array as PropType<number[]>,
      required: true,
    },
    refreshData: Function,
  },
  emits: ["toggle-modal"],
  data() {
    return {
      deviceTypeMetadataService: new DeviceTypeMetadataService(),
      deviceTypeMetadata: [] as DeviceTypeMetadata[],
      toast: useToast(),
      deviceTypeMetadataId: null as number | null,
      isLoading: false,
      isSubmitLoading: false,
    };
  },

  async created() {
    this.isLoading = true;
    try {
      await this.getDeviceTypeMetadata();
    } catch (error) {
      this.toast.error(ErrorMessageFormatter(error));
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    async handleSubmit() {
      if (!this.deviceTypeMetadataId) {
        throw new Error("Device type metadata id is not set");
      }
      this.isSubmitLoading = true;
      try {
        await this.deviceTypeMetadataService.createDeviceTypeMetadataRelation({
          deviceTypeMetadataId: this.deviceTypeMetadataId,
          deviceTypeIdList: this.deviceTypeIdList,
        });
        this.toast.success((this as any).$t("General.CreatedSuccessfully"));
        this.$emit("toggle-modal");
        await this.refreshData?.();
      } catch (error) {
        this.toast.error(ErrorMessageFormatter(error));
      } finally {
        this.isSubmitLoading = false;
      }
    },
    async getDeviceTypeMetadata() {
      try {
        this.deviceTypeMetadata =
          await this.deviceTypeMetadataService.getDeviceTypeMetadata();
      } catch (error) {
        this.toast.error(ErrorMessageFormatter(error));
      }
    },
  },
});
</script>

<style scoped></style>
